<template>
  <v-autocomplete
    :readonly="readonly"
    :label="label"
    :filled="filled"
    :error-messages="errorMessages"
    prepend-inner-icon="fa-user-circle"
    placeholder="Selecciona un cliente"
    clearable
    v-model="selected"
    :search-input.sync="search"
    :items="items"
    :loading="loading"
    return-object
  >
    <template v-slot:no-data="">
      <div class="pa-1 text-center">
        No se encontraron coincidencias
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
import {ApiUtils} from "@/utils/ApiUtils";
import {debounce} from "@/utils/Common";

export default {
  name: "ProviderPicker",
  props:{
    readonly:{
      type: Boolean,
      default: false
    },
    errorMessages:{
      type: String,
      default: ''
    },
    value:{
      type: Object,
    },
    filled:{
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'Buscar Proveedor de Servicios'
    }
  },
  data(){
    return {
      loading: false,
      selected: null,
      search: '',
      providers: []
    }
  },
  mounted(){
    const vm = this
    vm.setDefaults()
  },
  methods:{
    setDefaults(){
      const vm = this
      if(vm.value){
        vm.selected = vm.value
      }
    },
    debouncedSearch: debounce(function(){
      this.searchProviders()
    }, 500),
    async searchProviders(){
      const vm = this

      const filters = {
        name: vm.search
      }

      vm.loading = true
      const response = await ApiUtils.makeGet('public/providers', filters)
      vm.loading = false

      if(!response.ok){
        return vm.providers = []
      }

      const json = await response.json()
      vm.providers = json.result.providers.data

    }
  },
  computed:{
    items(){
     const vm = this
     return vm.providers.map(provider => {

       return {
         text: provider.name,
         value: provider.id,
         data: provider
       }

     })
    }
  },
  watch:{
    search(){
      const vm = this
      vm.debouncedSearch()
    },
    value(){
      const vm = this
      vm.setDefaults()
    },
    selected(val){
      const vm = this
      vm.$emit('change', val)
    }
  }
}
</script>

<style scoped>

</style>
